import React from 'react';
import gif from "../../../Assets/casa-en-la-niebla-GIF.gif"
import "./Loading.css"


const Loading = () => {
    return (
        <div className='gif'>
            <img className='gif' src={gif} alt="" />
        </div>
    );
}

export default Loading;
